/* @flow */
/**
 * Created by Ondra on 10.11.2016.
 */
import React from 'react';
import {connect} from 'react-redux'
import {
    closeDivideTable, dividePayAll, divideRemoveAll, markDivideItem, divideMoveFromTo, divideMoveToFrom, openTables,
    divideCountDecrease, divideCountIncreaseHalf, divideCountIncrease, setDividePcsKeyboard
} from '../../common/tables/actions';
import {openPaymentPopup} from '../../common/paymentPopup/actions';
import {List} from 'immutable';
import ProductRow from '../paymentPopup/ProductRow';
import {isOverflowedClass, findFirstElementByClassInElement} from '../../common/lib/util';
import {isElemetVisible} from '../../common/lib/visibility';
import CloseButton from '../components/buttons/CloseButton';
import ArrLeftButton from '../components/buttons/ArrLeftButton';
import ArrRightButton from '../components/buttons/ArrRightButton';

class DivideTable extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        setDividePcsKeyboard: React.PropTypes.func,
        divideCountDecrease: React.PropTypes.func,
        divideCountIncreaseHalf: React.PropTypes.func,
        divideCountIncrease: React.PropTypes.func,
        divideMoveFromTo: React.PropTypes.func,
        divideMoveToFrom: React.PropTypes.func,
        openTables: React.PropTypes.func,
        markDivideItem: React.PropTypes.func,
        closeDivideTable: React.PropTypes.func,
        openPaymentPopup: React.PropTypes.func,
        dividePayAll: React.PropTypes.func,
        divideRemoveAll: React.PropTypes.func,
        itemsDivideFrom: React.PropTypes.object,
        itemsDivideTo: React.PropTypes.object,
        markedDivideItem: React.PropTypes.number,
        countToDivide: React.PropTypes.number
    };

    constructor(props) {
        super(props);
        this.scrollByFrom = this.scrollByFrom.bind(this);
        this.scrollByTo = this.scrollByTo.bind(this);
        this.listMove = this.listMove.bind(this);
        this.scrollToSelectedItem = this.scrollToSelectedItem.bind(this);
    }

    scrollByFrom(up) {
        const parent = document.getElementsByClassName("scroll-from")[0];
        this.listMove(parent, up);
    }

    scrollByTo(up) {
        const parent = document.getElementsByClassName("scroll-to")[0];
        this.listMove(parent, up);
    }

    listMove(parent, up) {
        const {markedDivideItem, markDivideItem} = this.props;
        let id;
        if (!!markedDivideItem && parent.childNodes.length > 0) {
            const classToSelect = `item-${markedDivideItem}`;
            let selectedElement = findFirstElementByClassInElement(parent, classToSelect);

            if (!!selectedElement) {
                if (up) {
                    let previousElement = selectedElement.previousSibling;
                    if (!!previousElement) {
                        id = previousElement.getAttribute('data-id');
                    }
                } else {
                    let nextElement = selectedElement.nextSibling;
                    if (!!nextElement) {
                        id = nextElement.getAttribute('data-id');
                    }
                }
            } else {
                id = getFirstItemIdInList();
            }
        } else if (parent.childNodes.length > 0) {
            id = getFirstItemIdInList();
        }

        if (typeof id !== "undefined") {
            markDivideItem(parseInt(id));
        }

        function getFirstItemIdInList() {
            let selectedElement = findFirstElementByClassInElement(parent, 'row');
            if (!!selectedElement) {
                return selectedElement.getAttribute('data-id');
            }
        }
    }

    componentDidUpdate() {
        this.scrollToSelectedItem('scroll-from', 'active-from-receipt');
        this.scrollToSelectedItem('scroll-to', 'active-to-receipt');
    }

    scrollToSelectedItem(scrolledClass, activeElementClass) {
        const {markedDivideItem} = this.props;
        if (!!markedDivideItem) {
            const isOverflow = isOverflowedClass(scrolledClass);
            if (isOverflow){
                const div = document.getElementsByClassName(scrolledClass)[0];
                if (div.getElementsByClassName(activeElementClass).length > 0) {
                    const activeDiv = div.getElementsByClassName(activeElementClass)[0];
                    if (!isElemetVisible(activeDiv)) {
                        div.scrollTop = activeDiv.offsetTop;
                    }
                }
            }
        }
    }

    render() {
        const {
            closeDivideTable, openPaymentPopup, itemsDivideFrom, itemsDivideTo, markDivideItem, setDividePcsKeyboard,
            dividePayAll, divideRemoveAll, markedDivideItem, divideMoveFromTo, divideMoveToFrom,
            openTables, countToDivide, divideCountDecrease, divideCountIncreaseHalf, divideCountIncrease, msg
        } = this.props;

        return (
            <div className="pageSplit" id="split-table">
              <div className="pageSplit-receiptOriginal">
                <section className="receipt main">
                    <div className={`receipt-list view-full`}>
                        <div className="receipt-scroll scroll paymentScroll isOverflowFrom scroll-from">
                            {itemsDivideFrom
                                .sortBy(item => item.get('addTime'))
                                .map((item, i) =>
                                <ProductRow key={`items-from-${i}`}
                                            item={item}
                                            activeClass="active active-from-receipt"
                                            onClick={() => markDivideItem(item.get('id'))}
                                            marked={item.get('id') === markedDivideItem}/>
                            )}
                        </div>
                    </div>
                </section>
            </div>
              <div className="pageSplit-receiptNew">
                <section className="receipt">
                    <div className={`receipt-list view-full`}>
                        <div className="receipt-scroll scroll paymentScroll isOverflowTo scroll-to">
                            {itemsDivideTo
                                .sortBy(item => item.get('addTime'))
                                .map((item, i) =>
                                <ProductRow key={`items-to-${i}`}
                                            onClick={() => markDivideItem(item.get('id'))}
                                            activeClass="active active-to-receipt"
                                            marked={item.get('id') === markedDivideItem}
                                            item={item}/>
                            )}
                        </div>
                    </div>
                </section>
              </div>

              <div className="pageSplit-move">
                <section className="moveControl">
                  <div className="moveControl-key">
                    <div className={`boxBtn color-red ${countToDivide > 0 && !!markedDivideItem && !!itemsDivideTo.get(markedDivideItem) ? '' : 'disabled'}`}
                         onClick={() => divideMoveToFrom()}>
                        <ArrLeftButton className="view-white"/>
                    </div>
                  </div>

                  <div className="moveControl-count">
                    <div className="boxBtn text-l text-b">
                        <div className="boxBtn-inner">
                            <span>
                                {countToDivide}
                            </span>
                        </div>
                    </div>
                  </div>

                  <div className="moveControl-key">
                    <div className={`boxBtn color-red ${countToDivide > 0 && !!markedDivideItem && !!itemsDivideFrom.get(markedDivideItem) ? '' : 'disabled'}`}
                         onClick={() => divideMoveFromTo()}>
                        <ArrRightButton className="view-white"/>
                    </div>
                  </div>
                </section>
              </div>

              <div className="pageSplit-numboard">
                <section className="numpad">
                    {List.of(1, 2, 3, 4, 5, 6, 7, 8, 9).map(i =>
                      <div className="numpad-key" key={`keyboard-divide-${i}`}>
                        <div className="boxBtn color-green text-xl text-b"
                             onClick={() => setDividePcsKeyboard(i)}>
                            <div className="boxBtn-inner">{i}</div>
                        </div>
                      </div>
                    )}
                    <div className="numpad-key view-half">
                    <div className="boxBtn color-greenLight text-xl text-b" onClick={() => divideCountDecrease()}>
                        <div className="boxBtn-inner">
                            -
                        </div>
                    </div>
                    </div>
                  <div className="numpad-key">
                    <div className="boxBtn color-green text-xl text-b">
                        <div className="boxBtn-inner" onClick={() =>setDividePcsKeyboard(0)}>
                            0
                        </div>
                    </div>
                  </div>
                  <div className="numpad-key">
                    <div className="boxBtn color-green text-xl text-b" onClick={() => divideCountIncreaseHalf()}>
                        <div className="boxBtn-inner">
                            .5
                        </div>
                    </div>
                  </div>
                  <div className="numpad-key view-half">
                    <div className="boxBtn color-greenLight text-xl text-b" onClick={() => divideCountIncrease()}>
                        <div className="boxBtn-inner">
                            +
                        </div>
                    </div>
                  </div>
                </section>
              </div>

              <div className="pageSplit-control pageSplit-control-left">
                <section className="listControl list-control main">
                  <div className="listControl-key">
                    <div className={`boxBtn color-white arr`}
                         onClick={() => this.scrollByFrom(true)}>
                      <div className="boxBtn-inner"><div className="ico-up"></div></div>
                    </div>
                  </div>
                  <div className="listControl-key view-big">
                    <div className={`boxBtn color-white text-l text-up ${itemsDivideFrom.size === 0 ? 'disabled' : ''}`}
                         onClick={() => dividePayAll()}>
                        <div className="boxBtn-inner"><span>{msg.divideTable.payAll}</span></div>
                    </div>
                  </div>
                  <div className="listControl-key">
                    <div className={`boxBtn color-white`}
                         onClick={() => this.scrollByFrom(false)}>
                        <div className="boxBtn-inner"><div className="ico-down"></div></div>
                    </div>
                  </div>
                  <div className="listControl-key">
                    <div className="boxBtn">

                    </div>
                  </div>
                  <div className="listControl-key">
                    <div className="boxBtn">

                    </div>
                  </div>
                  <div className="listControl-key">
                    <div className="boxBtn">

                    </div>
                  </div>
                  <div className="listControl-key">
                    <div className="boxBtn">

                    </div>
              </div>
                  <div className="listControl-key">
                    <div className="boxBtn">

                    </div>
              </div>
                  <div className="listControl-key">
                    <div className="boxBtn">

                    </div>
              </div>
                  <div className="listControl-key">
                    <div className="boxBtn color-white close close-btn" onClick={() => closeDivideTable()}>
                        <CloseButton/>
                    </div>
                  </div>
                  <div className="listControl-key">
                    <div className="boxBtn">

                    </div>
                  </div>
                </section>
              </div>
              <div className="pageSplit-control pageSplit-control-right">
                <section className="listControl">
                  <div className="listControl-key view-big">
                    <div className={`boxBtn color-white text-up text-l ${itemsDivideTo.size === 0 ? 'disabled' : ''}`}
                         onClick={() => divideRemoveAll()}>
                        <div className="boxBtn-inner"><span>{msg.divideTable.removeAll}</span></div>
                    </div>
                  </div>
                  <div className="listControl-key">
                    <div className={`boxBtn color-white`}
                         onClick={() => this.scrollByTo(true)}>
                        <div className="boxBtn-inner"><div className="ico-up"></div></div>
                    </div>
                  </div>
                  <div className="listControl-key">
                    <div className="boxBtn">
                    </div>
                  </div>
                  <div className="listControl-key">
                    <div className="boxBtn">
                    </div>
                  </div>
                  <div className="listControl-key">
                    <div className={`boxBtn color-white arr`}
                         onClick={() => this.scrollByTo(false)}>
                        <div className="boxBtn-inner"><div className="ico-down"></div></div>
                    </div>
                  </div>
                  <div className="listControl-key">
                    <div className="boxBtn">

                    </div>
                  </div>
                  <div className="listControl-key">
                    <div className="boxBtn">

                    </div>
                  </div>
                  <div className="listControl-key">
                    <div className="boxBtn">

                    </div>
                  </div>
                  <div className="listControl-key view-half">
                    <div className={`boxBtn color-green text-l text-up ${itemsDivideTo.size === 0 ? 'disabled' : ''}`}
                         onClick={() => openTables()}>
                        <div className="boxBtn-inner"><span>{msg.divideTable.toBill}</span></div>
                    </div>
                  </div>
                  <div className="listControl-key view-half">
                    <div className={`boxBtn color-red text-lr text-up ${itemsDivideTo.size === 0 ? 'disabled' : ''}`}
                         onClick={() => openPaymentPopup()}
                    >
                        <div className="boxBtn-inner"><span>{msg.divideTable.pay}</span></div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
        );
    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    markedDivideItem: state.categories.get('markedDivideItem'),
    itemsDivideTo: state.categories.get('itemsDivideTo'),
    itemsDivideFrom: state.categories.get('itemsDivideFrom'),
    countToDivide: state.categories.get('countToDivide')
}), {
    closeDivideTable, openPaymentPopup, dividePayAll, divideRemoveAll, markDivideItem, divideMoveFromTo,
    divideMoveToFrom, openTables, divideCountDecrease, divideCountIncreaseHalf, divideCountIncrease,
    setDividePcsKeyboard
})(DivideTable);



// WEBPACK FOOTER //
// ./src/browser/tables/DivideTable.js